export const calculateChecks = (document) => {
  const passedCount = document.checks?.filter(({ passed }) => passed).length;
  const total = document.checks?.length;
  return {
    passedCount,
    passed: passedCount === total,
    total,
  };
};

export const getRequirementName = (rulesSchema, rawName) => {
  const configObject = rulesSchema?.variables?.find(
    ({ name }) => name === rawName,
  );
  return configObject?.label || '';
};

export const calculateVerificationsAndChecks = (
  document,
  omitFraudSignals = false,
) => {
  const nameVerification = document.verification?.name;
  const addressVerification = document.verification?.address;
  const companyVerification = document.verification?.company;
  const idNumberVerification = document.verification?.id_number;
  const stringsVerification = document.verification?.strings;
  let stringChecks = 0;
  let passedCount = 0;
  let total = 0;

  if (stringsVerification !== undefined) {
    stringChecks = stringsVerification.filter(
      ({ verified }) => verified,
    ).length;
  }

  // TODO: if we're omitting fraud signal, I attempted to do this with a ternary operator
  // but it worked in some cases, and not others, so this is a temporary fix which
  // will be reverted
  if (omitFraudSignals) {
    // new calculation remove fraud signals from the count of checks
    passedCount =
      document.checks?.filter(({ passed }) => passed).length +
      (nameVerification && nameVerification.verified ? 1 : 0) +
      (addressVerification && addressVerification.verified ? 1 : 0) +
      (companyVerification && companyVerification.verified ? 1 : 0) +
      (idNumberVerification && idNumberVerification.verified ? 1 : 0) +
      stringChecks;
    total =
      document.checks?.length +
      (nameVerification ? 1 : 0) +
      (addressVerification ? 1 : 0) +
      (companyVerification ? 1 : 0) +
      (idNumberVerification ? 1 : 0) +
      (stringsVerification ? stringsVerification.length : 0);
  } else {
    // existing calculation
    passedCount =
      document.checks?.filter(({ passed }) => passed).length +
      (document.is_fraudulent ? 0 : 1) +
      (nameVerification && nameVerification.verified ? 1 : 0) +
      (addressVerification && addressVerification.verified ? 1 : 0) +
      (companyVerification && companyVerification.verified ? 1 : 0) +
      (idNumberVerification && idNumberVerification.verified ? 1 : 0) +
      stringChecks;
    // Add one for the fraud check
    // and another for each name/address verification if present
    total =
      document.checks?.length +
      1 +
      (nameVerification ? 1 : 0) +
      (addressVerification ? 1 : 0) +
      (companyVerification ? 1 : 0) +
      (idNumberVerification ? 1 : 0) +
      (stringsVerification ? stringsVerification.length : 0);
  }

  return {
    passedCount,
    passed: passedCount === total,
    total,
  };
};

export const getChecksText = (passedBoolean, passedCount, totalChecks) => {
  const checkTitle = 'Check';
  const checkStatus = passedBoolean ? 'passed' : 'failed';
  const number = passedBoolean ? passedCount : totalChecks - passedCount;
  const pluralizeCheck = number > 1 ? `${checkTitle}s` : checkTitle;

  return {
    number,
    text: `${pluralizeCheck} ${checkStatus}`,
  };
};

export const getCheckSubtitle = (check) => {
  const notPassedCount = check.requirements.reduce((sum, nextVal) => {
    sum += nextVal.passed ? 0 : 1;
    return sum;
  }, 0);
  return check.passed
    ? 'Passed • All requirements met'
    : `Failed • ${notPassedCount} ${
        notPassedCount < 2 ? 'requirement' : 'requirements'
      } not met`;
};
